import React from 'react';
import { midas } from '@resurs/midas';
import { classNames } from '@resurs/hephaestus';
const Table = ({ children, striped, disableHover, dataCy }) => (React.createElement("table", { className: classNames(midas.table, !disableHover && midas.tableHover, striped && midas.tableStriped), "data-cy": dataCy }, children));
export default Table;
